/* eslint-disable */
import $ from 'jquery';
import BaseModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';
'use strict;';
var model = BaseModel.extend({
  defaults: $.extend({}, BaseModel.prototype.defaults, {
    Entity: 'Campaign',
    BatchAction: {
      Actions: [{
        '@odata.type': '#Model.TextAction',
        'Property': 'CampaignSettings/RSAAutoGeneratedAssetsEnabled',
        'ActionType': 'Set',
        'Value': '',
        'SearchString': '',
        'Options': 'None'
      }]
    }
  })
});
export default model;

